import ReportGroupsContainer from './containers/ReportGroupsContainer';
export default ReportGroupsContainer;
